const STORAGE_KEY = "unfold:recent_playbook_ids";
const MAX = 12;

export function readRecentPlaybookIds(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((v): v is string => typeof v === "string");
  } catch {
    return [];
  }
}

export function pushRecentPlaybookId(id: string): void {
  if (typeof window === "undefined" || !id) return;
  try {
    const current = readRecentPlaybookIds();
    const next = [id, ...current.filter((v) => v !== id)].slice(0, MAX);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
}
